import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
          )}
          {item.path ? (
            <Link
              to={item.path}
              className="text-foreground-400 hover:text-primary-400 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-200 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}